import React from 'react'
import styled from 'styled-components'

import { SIZES, COLORS, FONT_WEIGHTS } from '~/common/globalStyles'

const GroupWrapper = styled.div`
  border-top: 1px dashed ${COLORS.lightGray};

  &:first-child {
    border-top: 0;
  }
`

const GroupTitle = styled.div`
  margin-top: ${SIZES.small};
  cursor: default;
  text-align: left;
  padding: ${SIZES.tiny} ${SIZES.small};
  font-size: ${SIZES.medium};
  font-weight: ${FONT_WEIGHTS.bold};
  color: ${COLORS.mediumGray};
`

function mapArray(
  array,
  getItemProps,
  result,
  highlightedIndex,
  selectedItems,
  multi,
) {
  return array.map((child, dataIndex) => {
    const { value } = child.props
    const index = result ? result.itemIndex++ : dataIndex
    return React.cloneElement(child, {
      key: dataIndex,
      ...getItemProps({
        item: multi && value !== undefined ? value : { value },
        index,
        isActive: highlightedIndex === index,
        isSelected: multi
          ? selectedItems.includes(value)
          : selectedItems.value === value,
      }),
    })
  })
}

export function groupArray(
  getItemProps,
  inputValue,
  highlightedIndex,
  selectedItem,
  grouped,
  groupCriteria,
  filterMethod,
  childrenArrayProp,
  multi,
) {
  const childrenArray = childrenArrayProp.filter((child) =>
    filterMethod(child, inputValue),
  )

  let ResultComponent = null
  const groupedArray = (groupCriteria && groupCriteria(childrenArray)) || []
  let hasElements = false
  groupedArray.forEach((element) => {
    const { title, data } = element
    if (title && data.length > 0) hasElements = true
  })
  if (grouped && hasElements) {
    ResultComponent = groupedArray.reduce(
      (result, { data, title }, index) => {
        result.groups.push(
          <GroupWrapper key={index}>
            {title && <GroupTitle>{title}</GroupTitle>}
            {mapArray(
              data,
              getItemProps,
              result,
              highlightedIndex,
              selectedItem,
              multi,
            )}
          </GroupWrapper>,
        )
        return result
      },
      { groups: [], itemIndex: 0 },
    ).groups
  } else {
    ResultComponent = (
      <React.Fragment>
        {mapArray(
          childrenArray,
          getItemProps,
          null,
          highlightedIndex,
          selectedItem,
          multi,
        )}
      </React.Fragment>
    )
  }

  return ResultComponent
}
